import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { TNotificationCenterFilter,TPaginatedNotifications } from "../types/notification.type";

import { BaseHttpService } from "@app/core/services/base-http.service";
import { TResponse, TTableFilter } from "@app/core/types/response.type";

@Injectable({ providedIn: "root" })
export class NotificationsApiService {
  private readonly http = inject(BaseHttpService);

  getNotifications(filter: TTableFilter<TNotificationCenterFilter>): Observable<TResponse<TPaginatedNotifications>> {
    return this.http.post<TResponse<TPaginatedNotifications>>("notification/filter", filter);
  }

  markAsRead(notificationId: string): Observable<TResponse<string>> {
    return this.http.post<TResponse<string>>(`notification/${notificationId}/read`, {});
  }

  markAllAsRead(): Observable<TResponse<number>> {
    return this.http.post<TResponse<number>>("notification/read-all", {});
  }

  markasRead(notificationId: string): Observable<TResponse<boolean>> {
    return this.http.post<TResponse<boolean>>(`notification/${notificationId}/read`, {})
  }

  fetchUnreadCount(): Observable<TResponse<number>> {
    return this.http.get<TResponse<number>>("notification/unread-count");
  }
}
